import { render } from "./CourseSidebarArea.vue?vue&type=template&id=b8c87c84"
import script from "./CourseSidebarArea.vue?vue&type=script&lang=js"
export * from "./CourseSidebarArea.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__